import React from "react";
import styles from "./Navhead.module.scss";
import TitlePageText from "../../Atoms/Texts/TitlePageText";
import userProfile from "../../../assets/Imagess/usreprofileicon.svg";
import signout from "../../../assets/Imagess/signout.svg";
import profileicon from "../../../assets/Imagess/sigmouticon.svg";
import { useNavigate } from "react-router-dom";
import MoreButton from "../Custom/MoreButton";
import backICon from "../../../assets/Imagess/backArrow.svg";
import { logoutSession } from "../../../services/session";

// import { PageTitleContext } from "../../HOC/GeneralBody/GeneralBody";
const Navhead = ({
  title,
  isArrow,
  moveRight = "",
  details,
  handleNavigateBack,
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/home/profile");
  };

  const handleSignOut = async () => {
    await logoutSession();
    navigate("/", { replace: true });
  };

  return (
    <div className={styles["navhead-container"]}>
      <div className={styles["navhead-subcontainer"]} id="navhead-subcontainer">
        {(isArrow || details != null) && (
          <img
            src={backICon}
            alt="back"
            onClick={handleNavigateBack}
            className={styles.backIcon}
          />
        )}

        <TitlePageText title={title} />
      </div>
      <div className={styles["navhead-subcontainer"]}>
        {/* <MoreButton icon={bellIcon} width="400px">
          <div className={styles["notifications-container"]}>
            <h3>Notifications</h3>
            <div>
              <h4>Lorem ipsum dolor</h4>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr</p>
            </div>
          </div>
        </MoreButton> */}
        <MoreButton
          icon={userProfile}
          profileImg="profile-img"
          width="200px"
          left="0"
        >
          <div className="profile-container">
            <div onClick={handleNavigate}>
              <img src={profileicon} alt="profile" /> <h4>ملفي الشخصي</h4>
            </div>
            <div onClick={handleSignOut}>
              <img src={signout} alt="profile" /> <h4>تسجيل الخروج</h4>
            </div>
          </div>
        </MoreButton>
      </div>
    </div>
  );
};

export default Navhead;
